import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';

export const isSafeAppPath = (value) =>
  value?.startsWith('/') && !value.startsWith('//');

export function resolvePostLoginPath({ redirectTo, memberships = [], hasPendingOnboarding = false }) {
  const hasSingleMembership = memberships.length === 1;
  const hasMultipleMemberships = memberships.length > 1;

  if (isSafeAppPath(redirectTo)) {
    const isSubscriptionOnboarding = redirectTo === '/onboarding'
      || redirectTo.startsWith('/onboarding?');
    const isSubscriptionEntry = isSubscriptionOnboarding || redirectTo === '/welcome';

    if (isSubscriptionEntry && hasSingleMembership) {
      return `${APP_ROUTE_PREFIX}/${RouteConstant.dashboard}`;
    }

    if (isSubscriptionEntry && hasMultipleMemberships) {
      return `${APP_ROUTE_PREFIX}/${RouteConstant.tenantSelection}?continueTo=${encodeURIComponent(redirectTo)}`;
    }

    if (isSubscriptionOnboarding && hasPendingOnboarding) return '/welcome';

    return redirectTo;
  }

  if (hasSingleMembership) return `${APP_ROUTE_PREFIX}/${RouteConstant.dashboard}`;
  if (hasMultipleMemberships) return `${APP_ROUTE_PREFIX}/${RouteConstant.tenantSelection}`;
  return hasPendingOnboarding ? '/welcome' : '/get-started';
}
